import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getLideres = async () => {
    let lideres = null;
    try {
        const response = await api.get(`usuario/listcontroller`, config);
        lideres = response.data.data;
    } catch (err) {}
    return lideres;
}